import React, { Component } from 'react';

class Checkbox extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
    this.setState({ value: nextProps.defaultValue })
  }

  // toggleCheckboxChange = () => {
  //   const { handleCheckboxChange, label } = this.props;
  //
  //   this.setState(({ value }) => (
  //     {
  //       value: !value,
  //     }
  //   ));
  //
  //   // handleCheckboxChange(label);
  // }

  render() {
    const { label, name, group, value, onChange, disabled } = this.props;
    // const { value } = this.state;
    // console.log(this.props);
    return (
      <label className="input">
        <input
          disabled={disabled}
          id={name}
          data-group={group}
          className="input__field"
          type="checkbox"
          defaultValue={value}
          checked={value ? 'checked' : ''}
          onChange={onChange}
        />
        <span className="input__text">{label}</span>
      </label>
    );
  }
}



export default Checkbox;
